import { CHANNEL_ID_APP, CHANNEL_ID_HTTP_DEVICE } from '@/data/constants/order';
import { useMobileApp } from '@/data/state/useMobileApp';
import { resolveChannelId } from '@/data/utils/resolveChannelId';

const MOBILE_BROWSER_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

/**
 * Resolves the sales channel id (BUSCHN_ID) of the request completing
 * checkout, so it can be sent to the backend when adding a payment
 * instruction and the order is attributed to the correct channel.
 */
export const useChannelId = () => {
	const { isMobileApp } = useMobileApp();
	const isMobileBrowser =
		typeof navigator !== 'undefined' && MOBILE_BROWSER_REGEX.test(navigator.userAgent);

	return resolveChannelId([
		[isMobileApp, CHANNEL_ID_APP],
		[isMobileBrowser, CHANNEL_ID_HTTP_DEVICE],
	]);
};
